import React from 'react';
import NYXLogo from './img/NYX_noCode_Combined.png';
import NYXNoCode2 from './img/NYXNoCode.png';
import mascots from './img/mascots.png';
import './NYXNoCode.css';

const NYXNoCode = () => (

    <div className="hero">
        <p>
            NYX NoCode is the engine behind <a href={"https://www.nyx.baby/hacktopia"}>Hacktopia</a>, a transformative experience where students collaborate, build, and innovate with the support of cutting-edge tools. NYX NoCode isn’t available as a standalone product—it’s exclusively accessible as part of the Hacktopia program, where students learn by doing and create real projects during themed hackathon-style challenges.
        </p>

        <div className="nyx-nocode-header">
            <img src={NYXLogo} alt="NYX NoCode" className="nyx-nocode-hero-img" />
            <h1 className="headerTitle">How NYX NoCode Powers Hacktopia</h1>
        </div>

        <div >



            <h2>NYX NoCode: Created for Creators</h2>
            <p>
                Named after Nyx, the ancient Greek Goddess of the Night, NYX NoCode embodies creativity, magic, and empowerment. Just as the night sky inspires wonder, NYX NoCode invites students to imagine boldly and build beautifully—without writing a single line of code.
            </p>
            <p>
                Originally developed by technologist and educator Karen Kilroy, NYX NoCode gives students the power to create interactive web pages and simple applications by simply describing what they want—or even by drawing a doodle! A sentence becomes a working prototype in seconds. The result: students focus on ideas, not syntax.
            </p>
             <h2>Guided by Mascot Magic</h2>
            <p>
                Each Hacktopia event is co-hosted by a custom LLM-powered character we call Justin Mascot—a generative AI persona that adopts the identity of the school’s mascot. Justin Mascot acts as a supportive partner, offering guidance, feedback, and encouragement throughout the experience.
            </p>
            <img src={mascots} alt="Justin Mascot" className="nyx-nocode-mascot-image" />

            <p>
                Whether students are brainstorming ideas, writing content, or figuring out how to structure a page, Justin Mascot is there to help—fostering confidence and autonomy with every prompt.
            </p>
            <p>
            <img src={NYXNoCode2} alt="NYX NoCode, Goddess of the Night, Creator of Beautiful, Functional Web Applications" className="inset-image" />
        </p>
            <h2>Empowerment Through Hacktopia</h2>
            <p>
                Hacktopia isn't a competition so much as a launchpad for creativity. Students don't just learn how to use technology—they become creators of technology. With NYX NoCode and Justin Mascot guiding the way, every participant discovers they have the power to build something impactful.
            </p>
            <p>
                Learn more about how <a href="https://nyx.baby/NYX-NoCode">NYX NoCode powers educational innovation</a> in classrooms and hackathon environments.
            </p>
            <h2>What Makes NYX NoCode Unique</h2>
            <ul>
                <p><strong>Prompt-Based Interface</strong> – Students build using natural language, learning how to structure requests and translate ideas into working code.</p>
                <p><strong>Intuitive Visual Design</strong> – Everything students create is presented in a clean, responsive format they can customize.</p>
                <p><strong>Built-In Creativity</strong> – With a growing prompt library, students can remix existing ideas or invent entirely new ones.</p>
                <p><strong>Multi-Language Support</strong> – NYX understands and generates in many languages, opening up access for diverse learners.</p>
                <p><strong>No-Code, Real Results</strong> – Finished projects look and feel professional—whether it’s a portfolio, a storytelling app, or a business idea prototype.</p>
            </ul>


            <h2>Teachers as Co-Learners and Guides</h2>
            <p>
                Hacktopia is built on a teacher-centric model that empowers educators as co-learners and facilitators. In the rapidly evolving world of AI and no-code tools, teachers engage side-by-side with students—exploring, experimenting, and growing their own digital fluency in real time.
            </p>
            <p>
                With NYX NoCode, teachers don’t need to be tech experts to lead transformative experiences. Instead, they model curiosity, creativity, and critical thinking while guiding students through meaningful, project-based learning. Our program supports educators every step of the way, making it easy to integrate AI-powered creation into the classroom.
            </p>
        </div>

    </div>

);

export default NYXNoCode;
